import type { CSSProperties } from 'react';
import mapboxgl from 'mapbox-gl';

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiZGF2aWQtcGV0dGlmb3ItbmQiLCJhIjoiY200dDNjbWtpMDdlZjJqcHM1ODhkOWF4OSJ9.PQL7pNkiko1SbYsmNrvacQ';

/** Minimal style: solid background only (no streets, labels, or terrain). */
export const ADMIN_FLAT_MAP_STYLE: mapboxgl.Style = {
  version: 8,
  sources: {},
  layers: [
    {
      id: 'background',
      type: 'background',
      paint: { 'background-color': '#e9ecef' },
    },
  ],
};

export const adminMapContainerStyle: CSSProperties = {
  width: '100%',
  borderRadius: '4px',
  overflow: 'hidden',
  border: '1px solid #dee2e6',
};

/**
 * Choropleth map: region clicks + zoom/pan (no rotate or pitch).
 * @param center [latitude, longitude]
 */
export function createAdminChoroplethMap(
  container: HTMLElement,
  center: [number, number],
  zoom: number,
): mapboxgl.Map {
  mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
  const map = new mapboxgl.Map({
    container,
    style: ADMIN_FLAT_MAP_STYLE,
    center: [center[1], center[0]],
    zoom,
    minZoom: 1,
    maxZoom: 8,
    pitch: 0,
    bearing: 0,
    interactive: true,
    attributionControl: true,
    logoPosition: 'bottom-right',
    fadeDuration: 0,
  });

  map.addControl(
    new mapboxgl.NavigationControl({ showCompass: false }),
    'top-right',
  );

  map.scrollZoom.enable();
  map.doubleClickZoom.enable();
  map.dragPan.enable();
  map.boxZoom.enable();
  map.keyboard.enable();

  map.dragRotate.disable();
  map.touchZoomRotate.enable();
  map.touchZoomRotate.disableRotation();

  return map;
}
